import * as React from "react";

import { Store, useForceRender } from "..";

export function useStore<T, U>(store: Store<T>, selector: (state: T) => U): U {
  const forceRender = useForceRender();

  const selectorRef = React.useRef(null);
  const valueRef = React.useRef(null);

  selectorRef.current = selector;
  valueRef.current = store.select(selector);

  React.useEffect(() => {
    const subCancelCB = store.subscribe(() => {
      const currentValue = store.select(selectorRef.current);
      if (valueRef.current !== currentValue) {
        forceRender();
      }
    });
    return () => {
      subCancelCB();
    };
  }, [store, selectorRef.current, valueRef.current]);

  return valueRef.current;
}
